import React from "react";
import Logo from "../assets/images/UT_Horz_Yellow.svg";
import MountainSilhouette from "../assets/images/utah-footer.svg";

const FooterSection = () => {
  return (
    <footer className="tu-footer">
      {/* Mountain silhouette */}
      <div className="tu-footer__mountains">
        <img src={MountainSilhouette} alt="" className="tu-footer__mountainsImg" aria-hidden="true" />
      </div>

      {/* Main body */}
      <div className="tu-footer__body">
        {/* Background decoration */}
        <div className="tu-footer__bgPattern" aria-hidden="true" />

        <div className="tu-footer__inner">
          {/* Brand column */}
          <div className="tu-footer__brand">
            <a href="/" className="tu-footer__logoLink">
              <img src={Logo} alt="Transparent Utah" className="tu-footer__logo" />
            </a>
            <p className="tu-footer__desc">
              A government transparency initiative by the{" "}
              <a
                href="https://auditor.utah.gov/"
                target="_blank"
                rel="noopener noreferrer"
                className="tu-footer__descLink"
              >
                Office of the State Auditor
              </a>
              , providing public access to state and local government spending,
              compensation, and financial data.
            </p>

            <div className="tu-footer__contactGroup">
              <a href="tel:8015381025" className="tu-footer__contactItem">
                <span className="tu-footer__contactBubble">
                  <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                  </svg>
                </span>
                <span className="tu-footer__contactText">801-538-1025</span>
              </a>
              <a href="mailto:transparent@utah.gov" className="tu-footer__contactItem">
                <span className="tu-footer__contactBubble">
                  <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
                  </svg>
                </span>
                <span className="tu-footer__contactText">transparent@utah.gov</span>
              </a>
              <div className="tu-footer__contactItem tu-footer__contactItem--static">
                <span className="tu-footer__contactBubble">
                  <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" />
                  </svg>
                </span>
                <span className="tu-footer__contactText">Utah State Capitol, Suite 260<br />Salt Lake City, UT 84114</span>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="tu-footer__divider" />

          {/* Link columns */}
          <div className="tu-footer__columns">
            <div className="tu-footer__col">
              <span className="tu-footer__colTitle">
                <span className="tu-footer__colTitleBar" />
                Quick Links
              </span>
              <ul className="tu-footer__list">
                <li><a href="/" className="tu-footer__link">Home</a></li>
                <li><a href="https://old.transparent.utah.gov/about.php" target="_blank" rel="noopener noreferrer" className="tu-footer__link">About</a></li>
                <li><a href="/help" target="_blank" rel="noopener noreferrer" className="tu-footer__link">Help &amp; FAQs</a></li>
                <li><a href="https://old.transparent.utah.gov/resources.php" target="_blank" rel="noopener noreferrer" className="tu-footer__link">Resources</a></li>
                <li><a href="https://auditor.utah.gov/" target="_blank" rel="noopener noreferrer" className="tu-footer__link">State Auditor</a></li>
              </ul>
            </div>

            <div className="tu-footer__col">
              <span className="tu-footer__colTitle">
                <span className="tu-footer__colTitleBar" />
                Popular Tools
              </span>
              <ul className="tu-footer__list">
                <li><a href="/employees/employee-search" target="_blank" rel="noopener noreferrer" className="tu-footer__link">Employee Pay Search</a></li>
                <li><a href="/employees/highest-paid-employees" target="_blank" rel="noopener noreferrer" className="tu-footer__link">Highest Paid Employees</a></li>
                <li><a href="/entities/entity-overview-dashboard" target="_blank" rel="noopener noreferrer" className="tu-footer__link">Entity Overview</a></li>
                <li><a href="https://old.transparent.utah.gov/job_title_search.php" target="_blank" rel="noopener noreferrer" className="tu-footer__link">Job Pay Search</a></li>
                <li><a href="https://transparent.utah.gov/teacher-pay/" target="_blank" rel="noopener noreferrer" className="tu-footer__link">Teacher Pay</a></li>
                <li><a href="https://old.transparent.utah.gov/vendet.php" target="_blank" rel="noopener noreferrer" className="tu-footer__link">Vendor Payments</a></li>
              </ul>
            </div>

            <div className="tu-footer__col">
              <span className="tu-footer__colTitle">
                <span className="tu-footer__colTitleBar" />
                Super Users
              </span>
              <ul className="tu-footer__list">
                <li><a href="https://old.transparent.utah.gov/superuser.php" target="_blank" rel="noopener noreferrer" className="tu-footer__link">Resource Center</a></li>
                <li><a href="https://old.transparent.utah.gov/how_to_become_superuser.php" target="_blank" rel="noopener noreferrer" className="tu-footer__link">Become a Super User</a></li>
                <li><a href="https://old.transparent.utah.gov/database_schema.php" target="_blank" rel="noopener noreferrer" className="tu-footer__link">Available Fields</a></li>
                <li><a href="https://old.transparent.utah.gov/superuser_scripts.php" target="_blank" rel="noopener noreferrer" className="tu-footer__link">Example SQL Scripts</a></li>
                <li><a href="https://old.transparent.utah.gov/superuser_query_with_r.php" target="_blank" rel="noopener noreferrer" className="tu-footer__link">Query with Python/R</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* ── Disclaimer bar ── */}
      <div className="tu-footer__disclaimer">
        <div className="tu-footer__disclaimerInner">
          <span className="tu-footer__disclaimerLabel">Disclaimer</span>
          <p className="tu-footer__disclaimerText">
            Please note that the data contained on this website is raw, unaudited, and unconsolidated data and therefore may not match any audited or printed financial statements. Also, this website does not contain information that is considered private or protected by state or federal law.{" "}
            <a
              href="https://old.transparent.utah.gov/disclaimers.php"
              target="_blank"
              rel="noopener noreferrer"
              className="tu-footer__disclaimerLink"
            >
              View all Disclaimers
            </a>
          </p>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="tu-footer__bottom">
        <div className="tu-footer__bottomInner">
          <p className="tu-footer__copyright">
            &copy; 2026 State of Utah &middot; Office of the State Auditor
          </p>
          <div className="tu-footer__legal">
            <a href="https://www.utah.gov/disclaimer.html" target="_blank" rel="noopener noreferrer" className="tu-footer__legalLink">Terms of Use</a>
            <span className="tu-footer__legalDot">&middot;</span>
            <a href="https://auditor.utah.gov/privacy-policy/" target="_blank" rel="noopener noreferrer" className="tu-footer__legalLink">Privacy Policy</a>
            <span className="tu-footer__legalDot">&middot;</span>
            <a href="https://old.transparent.utah.gov/disclaimers.php" target="_blank" rel="noopener noreferrer" className="tu-footer__legalLink">Disclaimers</a>
            <span className="tu-footer__legalDot">&middot;</span>
            <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer" className="tu-footer__legalLink">CC BY 4.0</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;